// react-i18next initialization. The canonical platform namespaces
// (`platform`, `ui`, `codes`) come first per RFC-0007; `gfo` is the
// app's own. `platform` is seeded from PLATFORM_LOCALES so the
// platform-shipped tables and forms render in the active locale.
//
// Catalog files live under `./locales/<locale>/<namespace>.json`. See
// `./locales/README.md` for who authors each namespace and how new
// locales get added.

import { createI18n, PLATFORM_LOCALES, PODIUM_NAMESPACES } from '@podium/platform/i18n'

import bgCodes from './locales/bg/codes.json'
import bgGfo from './locales/bg/gfo.json'
import bgUi from './locales/bg/ui.json'
import enCodes from './locales/en/codes.json'
import enGfo from './locales/en/gfo.json'
import enUi from './locales/en/ui.json'

export const i18n = createI18n({
  defaultLocale: 'bg',
  fallbackLocale: 'en',
  namespaces: [...PODIUM_NAMESPACES, 'gfo'],
  resources: {
    en: { platform: PLATFORM_LOCALES['en']!, ui: enUi, codes: enCodes, gfo: enGfo },
    bg: { platform: PLATFORM_LOCALES['bg']!, ui: bgUi, codes: bgCodes, gfo: bgGfo },
  },
})
